// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type UpdateServerGroupMutationVariables = Types.Exact<{
  serverGroupId: Types.Scalars["ID"]["input"];
  name?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
}>;

export type UpdateServerGroupMutation = {
  __typename?: "Mutation";
  updateServerGroup: {
    __typename?: "UpdateServerGroupPayload";
    errors: Array<string>;
    serverGroup: {
      __typename?: "ServerGroup";
      id: string;
      name: string;
      clusterId?: string | null;
      permittedToEdit: boolean;
    };
  };
};

export const UpdateServerGroupDocument = gql`
  mutation UpdateServerGroup($serverGroupId: ID!, $name: String) {
    updateServerGroup(serverGroupId: $serverGroupId, name: $name) {
      errors
      serverGroup {
        id
        name
        clusterId
        permittedToEdit
      }
    }
  }
`;
export type UpdateServerGroupMutationFn = Apollo.MutationFunction<
  UpdateServerGroupMutation,
  UpdateServerGroupMutationVariables
>;

/**
 * __useUpdateServerGroupMutation__
 *
 * To run a mutation, you first call `useUpdateServerGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServerGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServerGroupMutation, { data, loading, error }] = useUpdateServerGroupMutation({
 *   variables: {
 *      serverGroupId: // value for 'serverGroupId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateServerGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateServerGroupMutation,
    UpdateServerGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateServerGroupMutation,
    UpdateServerGroupMutationVariables
  >(UpdateServerGroupDocument, options);
}
export type UpdateServerGroupMutationHookResult = ReturnType<
  typeof useUpdateServerGroupMutation
>;
export type UpdateServerGroupMutationResult =
  Apollo.MutationResult<UpdateServerGroupMutation>;
export type UpdateServerGroupMutationOptions = Apollo.BaseMutationOptions<
  UpdateServerGroupMutation,
  UpdateServerGroupMutationVariables
>;
